'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PropertyCardRootContext } from './context/property-card-root.context';
import { propertyCardPhotoBodyRecipe } from './styles/property-card-photo-body.styles';
import type { PropertyCardPhotoBodyPropsInterface } from './types/property-card-photo-body.types';

/**
 * A container for a `PropertyCard.Photo` or `PhotoCarousel` in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export const PropertyCardPhotoBody = forwardRef<
  HTMLDivElement,
  PropertyCardPhotoBodyPropsInterface
>((props: PropertyCardPhotoBodyPropsInterface, forwardedRef) => {
  const { appearance, loading: contextLoading } = useContext(PropertyCardRootContext);
  const { children, className, css: cssProp, loading = contextLoading || false, ...rest } = props;

  const styles = css(propertyCardPhotoBodyRecipe.raw({ appearance, loading }), cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.PhotoBody"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_property-card__photo-body', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardPhotoBody.displayName = 'PropertyCard.PhotoBody';
